<template>
  <div :class="`${el}__step3`">
    <CareLevelChecker
      :loading="loading"
      :noCopy="$t('intro.step4.box.no')"
      :ctaLabel="$t('intro.step4.button')"
      :back="back"
      @onClickCta="$emit('click')"
      @trackBackBtnClick="
        $emit('onTrackingClick', '_link-' + $t('careLevelChecker.backButton'), 'link')
      "
    />
  </div>
</template>

<script>
import CareLevelChecker from '@/components/CareLevelChecker';

export default {
  name: 'Step4',
  props: {
    el: String,
    href: String,
    back: String,
    loading: Boolean,
  },
  components: {
    CareLevelChecker,
  },
  data() {
    return {};
  },
};
</script>
